<div class="mx-auto flex w-full items-center justify-center overflow-hidden" [class]="maxWidthClass()">
  <div class="animated-sensei z-1 absolute flex items-center justify-center">
    <img src="assets/images/sensei/sensei-shocked.svg" alt="Dojo" />
  </div>

  <div class="animated-block-text z-1 relative">
    @if (header) {
      <p class="text-display-xl mb-5 text-center font-semibold text-white">{{ header }}</p>
    }

    @if (description) {
      <p class="text-md mx-auto mb-6 max-w-[90%] text-center text-white">{{ description }}</p>
    } @else {
      <div
        class="text-md text-neutral-0 mx-auto mb-6 max-w-[90%] text-center"
        [class.hidden]="!ngContentDescription.children.length"
        #ngContentDescription
      >
        <ng-content select="[y42FullscreenMessageDescription]" />
      </div>
    }

    <div class="text-center">
      <ng-content select="footer">
        <dojo-button (click)="goToHome()" class="mx-auto flex w-[178px]">Return Home</dojo-button>
      </ng-content>
    </div>
  </div>
</div>
